import { formatMoney, formatSortCode } from 'lib/utils';
import { accountRolesLookup, currencies } from 'lib/constants';
import useTranslate from 'lib/languages/useTranslate';
import { toCamelCase } from 'utils/generic';
import { IAccount } from 'lib/type';

interface AccountOverviewProps {
    account: {
        accountName: IAccount['accountName'];
        productType: IAccount['productType'];
        bankAccountNo: IAccount['bankAccountNo'];
        sortCode: IAccount['sortCode'];
        availableBalance: IAccount['availableBalance'];
        clearedBalanceCurrencyCode: IAccount['clearedBalanceCurrencyCode'];
    };
}

const AccountOverview = ({ account }: AccountOverviewProps) => {
    const {
        accountName,
        productType,
        bankAccountNo,
        sortCode,
        availableBalance,
        clearedBalanceCurrencyCode,
    } = account;
    const translate = useTranslate('accountOverview');

    return (
        <div className="account-overview-container">
            <div className="account-select">
                <div className="account-details-wrapper">
                    <p>
                        <strong>
                            {accountName || 'Unknown'} -{' '}
                            {translate(
                                toCamelCase(
                                    accountRolesLookup[productType] || '',
                                ),
                            )}
                        </strong>
                    </p>
                </div>
                <p className="account-number">
                    {translate('accountNo', {
                        bankAccountNo,
                        sortCode: formatSortCode(sortCode),
                    })}
                </p>
            </div>
            <p className="amount-label">{translate('amountLabel')}</p>
            <p className="amount">
                <strong>
                    {currencies[clearedBalanceCurrencyCode]}
                    {formatMoney(availableBalance)}
                </strong>
            </p>
        </div>
    );
};

export default AccountOverview;
